var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.711 2.18537C13.3933 -0.728454 17.599 -0.728456 19.2813 2.18536L30.4003 21.4439C32.0826 24.3577 29.9797 28 26.6151 28H4.37725C1.01266 28 -1.09021 24.3577 0.592088 21.4439L11.711 2.18537Z",
    fill: "#BC1313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 8.28853L16.9498 18.3809H14.0308L13.7041 8.28853H17.2765ZM15.4868 23.04C14.9801 23.04 14.5445 22.86 14.18 22.5002C13.8201 22.1403 13.6402 21.7047 13.6402 21.1934C13.6402 20.6915 13.8201 20.263 14.18 19.9078C14.5445 19.548 14.9801 19.3681 15.4868 19.3681C15.9745 19.3681 16.403 19.548 16.7723 19.9078C17.1463 20.263 17.3334 20.6915 17.3334 21.1934C17.3334 21.5343 17.2458 21.8444 17.0706 22.1238C16.9001 22.4031 16.6752 22.6257 16.3959 22.7914C16.1212 22.9571 15.8182 23.04 15.4868 23.04Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3106ca709e8f718e8b4b6857b386345d.svg";
export { ForwardRef as ReactComponent };